import { Component } from '@angular/core'
import { AutomationEventTypes, AutomationTypes } from '@tokeet-frontend/automations'
import { FormBuilder } from '@angular/forms'
import { select, Store } from '@ngrx/store'
import { AutomationWizardPanelBaseComponent } from '@tv3/containers/automations/automations-wizard/automation-wizard-panel.component'
import { guestIncidentNotificationMessages, userIncidentNotificationMessages } from './messages'
import * as moment from 'moment'
import { AuthService } from '@tv3/services/auth.service'
import { selectAllIncidentCategories } from '@tokeet-frontend/incident'
import { Actions } from '@ngrx/effects'

@Component({
  selector: 'app-incident-automation-wizard',
  templateUrl: './incident-automation-wizard.component.html',
  styleUrls: ['./incident-automation-wizard.component.scss'],
})
export class IncidentAutomationWizardComponent extends AutomationWizardPanelBaseComponent {
  type = AutomationTypes.Incident

  guestNotificationMessages = guestIncidentNotificationMessages
  userNotificationMessages = userIncidentNotificationMessages

  categories$ = this.store.pipe(select(selectAllIncidentCategories))

  taskForNewIncident = {
    name: $localize`An Incident occurred`,
    user_ids: [this.auth.user.id],
    notes: $localize`An Incident occurred, please investigate it and take appropriate action.`,
    timezone: moment.tz.guess(),
  }

  constructor(
    private auth: AuthService,
    protected fb: FormBuilder,
    protected actions: Actions,
    protected store: Store<any>
  ) {
    super(actions, store, fb)
    this.form.addControl('categories', this.fb.control([]))
    this.form.patchValue({ event: AutomationEventTypes.IncidentCreated })
  }
}
